import { bunja } from 'bunja';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { tpslModalSegmentBunja } from '../segment';

export const tpslManageSegmentBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { commonEventPayloadAtom } = bunja.use(tpslModalSegmentBunja);

  function trackTpslSettingPartialSlotClick(buttonType: 'Modify' | 'Remove') {
    const { tpsl_type } = store.get(commonEventPayloadAtom);
    segment.track(TradeEvent.TpslSettingPartialSlotClick, {
      view_log_name: 'tpsl_setting_view',
      view_title: tpsl_type,
      button_type: buttonType,
    });
  }

  function trackTpslRemoveDialogView(tpslType: 'tp' | 'sl') {
    const title = tpslType === 'tp' ? 'Remove Take Profit' : 'Remove Stop Loss';
    segment.track(TradeEvent.TpslRemoveDialogView, { title });
  }

  function trackTpslRemoveDialogClick(buttonType: 'Cancel' | 'Confirm') {
    const { tpsl_type } = store.get(commonEventPayloadAtom);
    segment.track(TradeEvent.TpslRemoveDialogClick, {
      view_log_name: 'tpsl_remove_dialog_view',
      view_title: tpsl_type,
      button_type: buttonType,
    });
  }

  return {
    trackTpslSettingPartialSlotClick,
    trackTpslRemoveDialogView,
    trackTpslRemoveDialogClick,
  };
});
tpslManageSegmentBunja.debugLabel = 'tpslManageSegmentBunja';
